// extracted by mini-css-extract-plugin
module.exports = {"card":"highlight_card__3wRRf","text":"highlight_text__RLOPY"};